import { render, staticRenderFns } from "./AccordionSubItemForeign.vue?vue&type=template&id=0b83bf11&scoped=true"
import script from "./AccordionSubItemForeign.vue?vue&type=script&lang=js"
export * from "./AccordionSubItemForeign.vue?vue&type=script&lang=js"
import style0 from "./AccordionSubItemForeign.vue?vue&type=style&index=0&id=0b83bf11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83bf11",
  null
  
)

export default component.exports